import script from "./LoadingFullScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingFullScreen.vue?vue&type=script&setup=true&lang=js"

import "./LoadingFullScreen.vue?vue&type=style&index=0&id=93aa9c80&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93aa9c80"]])

export default __exports__